// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"618":"61e7fd68","854":"4ab46d67"}[chunkId] + ".chunk.css";
};